import { LitElement, html } from "./-global.min.js"

export class HHExpandableContent extends LitElement {
  static properties = {
    isExpanded: { type: Boolean, state: true },
  }

  firstUpdated() {
    this.initialHeight = this.getAttribute("max-height") || "400"
    this.style.maxHeight = `${this.initialHeight}px`

    const btn = this.querySelector(".content-two-column__trigger")
    if (btn) {
      btn.addEventListener("click", () => {
        this.classList.add("is-expanded")
        // Expands to the calculated scroll height
        this.style.maxHeight = `${this.scrollHeight}px`
      })
    }
  }

  render() {
    return html`<slot></slot>`
  }
}

customElements.define("hh-expandable-content", HHExpandableContent)
